export const useStoreKeys = () =>
{
    const storeKeys = {
        all: ["stores"],
        list: () => [...storeKeys.all, "storelist"],
        storelist: (filters) => [...storeKeys.list(), { filters }],
        detail: (id) => [...storeKeys.storelist(), id],
      };
      return {storeKeys};
}